module.exports = __webpack_public_path__ + "static/media/valor2.72d6bde1.png";